import styled from 'styled-components'

export default styled.textarea`
  padding: 1em;
  background-color: ${(props) => props.theme.colors.gray3};
  font-size: ${(props) => props.theme.fontSizes[4]}px;
  color: ${(props) => props.theme.colors.primary};
  box-shadow: none;
  border-width: 0;
  width: 100%;
  border-radius: 0;
  &::placeholder {
    // text-transform: uppercase;
    font-style: italic;
    color: ${(props) => props.theme.colors.gray2};
    font-weight: ${(props) => props.theme.fontWeights[1]};
    letter-spacing: ${(props) => props.theme.letterSpacing};
  }
  &:active,
  &:focus {
    box-shadow: inset 0 0 0 1px ${(props) => props.theme.colors.primary};
  }
`
